/**
 * Storage 封装
 */
import config from '../config'

export default {
	// 设置
	setItem(key, val,storageType='localStorage') {
		let storage = this.getStorage(storageType)
		storage[key] = val
		window[storageType].setItem(config.namespace, JSON.stringify(storage))
	},
	// 获取
	getItem(key,storageType='localStorage') {
		return this.getStorage(storageType)[key]
	},
	// 获取变量
	getStorage(storageType='localStorage') {
		return JSON.parse(window[storageType].getItem(config.namespace) || '{}')
	},
	// 清空一项
	clearItem(key,storageType='localStorage') {
		let storage = this.getStorage(storageType)
		delete storage[key]
		window[storageType].setItem(config.namespace, JSON.stringify(storage))
	},
	// 清空所有
	clearAllLocalStorage() {
		window.localStorage.clear()
	},
	clearAllSessionStorage() {
		window.sessionStorage.clear()
	}
}
